<template>
<div class="popup-block">
  <Amount
    :columnDetails="column"
    :compareBy="compareBy"
    :consigneeIndex="consigneeIndex"
    :payment="payment"
    :invoiceStatus="invoiceStatus"
    :isReadOnly="isReadOnly(column)"
    v-on:updateCompareBy="updateCompareBy"
    v-on:updateClientAmount="updateClientAmount"
    v-on:addConversation="addConversation"
  />
              <div class="comment-pop" v-if="column.comments">
                <Popover placement="bottom-end" v-model="commentpop">
                  <div class="popover-primary">
                    <div class="popover-primary-header">
                      <h3>Comments</h3>
                      <span class="remove-icon" @click="commentpop=false">
                        <svgicon name="cancel" width="10" height="10" :original="true" />
                      </span>
                    </div>
                    <div class="popover-primary-body">
                      <div class="timeline-comment">
                        <div v-if="commentLoading">Loading ....</div>
                       <div class="content"
                            v-if="!commentLoading && comments.length"
                            v-for="comment in comments"
                            v-bind:key="comment._id">
                        <div class="content-item">
                         <div class="dot dot-indent"></div>
                        </div>
                        <div class="content-body" >
                          <div class="content-body-status">
                           <p class="content-item-title"> {{ (comment.user.name) ? comment.user.name : 'User' }} </p>
                           <p class="content-item-sec"> {{comment.create_at | moment("DD MMM YY | HH : mm A") }} </p>
                           <p class="content-item-primary"> {{comment.message}} </p>
                          </div>
                        </div>
                       </div>
                       <div v-if="!commentLoading && !comments.length">No Comments</div>

                      </div>
                    </div>
                  </div>
                  <div slot="reference">
                    <svgicon name="Comment-mark" @click="getComments()" width="10" height="10" :original="true" />
                  </div>
                </Popover>
 </div>
 </div>
</template>
<script>
import { mapState } from 'vuex';
import Amount from './amount';

export default {
  name: 'PaymentDetails',
  components: { Amount },
  props: {
    payment: Object,
    column: Object,
    consigneeIndex: {
      type: Number,
      default: 0,
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    invoiceStatus: Number,
    delivery_type: String,
  },
  data() {
    return {
      showLRdetail: false,
      commentpop: false,
      compareBy: this.column.compareBy,
    };
  },
  computed: {
    ...mapState('invoice', ['commentLoading', 'comments']),
  },
  methods: {
    async addConversation(comment) {
      try {
        const data = { comment, id: this.payment.order_id, type: 1, section: 1 };
        const result = await this.$store.dispatch('invoice/addComment', { data });
        if (result.error) {
          this.$error({ message: result.error });
        }
        if (result.length) {
          this.$success({ message: this.$getSuccess('COMMENTS_ADDED') });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    async getComments() {
      try {
        const result = await this.$store.dispatch('invoice/comments', { data: { id: this.payment.order_id, section: 1 } });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    updateCompareBy(data) {
      this.compareBy = true;
      // this.$emit("updateCompareBy", data);
    },
    updateClientAmount(data) {
      this.$emit(
        'updateColumnAmount',
        Object.assign(data, {
          rowIndex: this.rowIndex,
          hasKey: this.column.hasKey,
        }),
      );
    },
    isReadOnly(column) {
      let canEdit = false;
      // if (column.column === 'contract_price' && payment.order_type === 2) {
      //   canEdit = true;
      // } else if
      if (
        column.readonly ||
        !this.$invoice.canEditInvoice(this.invoiceStatus)
      ) {
        canEdit = true;
      } else if (!this.$hasPermission('verify_invoice')) {
        canEdit = true;
      }
      return canEdit;
    },
  },
};
</script>
<style lang="scss" scoped>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

input {
  border-color: transparent;
  background-color: transparent;
  outline: none;
}
.order-content {
  .el-popover__reference {
    cursor: pointer;
    padding: 2px 0;
  }
  .table-row {
    //padding: 0 15px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
.payment-popover {
  h3 {
    padding-left: 15px;
    text-transform: uppercase;
  }
  &.popover-primary {
    padding: 20px 20px 20px 10px;
  }
}
.primary-text {
  color: #008aff !important;
  font-family:$fontSemibold;
}
.sec-text {
  color: #969696;
  /*font-style: italic;*/
}
.error-text {
  color: #e74c3c;
  font-family:$fontSemibold;
}

.focus-contain {
  display: none;
  &-div {
    background-color: #fff;
    padding: 10px 15px;
    position: absolute;
    -webkit-box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
    box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
    margin-left: -10px;
    padding-right: 10px;
    margin-top: -11px;
    display: block;
    border-top: 1px solid #efefef;
    //width: 132px;
    min-width: 80px;
    &-list {
      padding: 7px 0;
    }
    &-text {
      color: #a5a5a5;
      font-size: 0.8rem;
      display: block;
      line-height: 20px;
      padding: 0;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }
}
.active {
  //width: 122px;
  display: block;
  height: 40px;
  position: relative;
  vertical-align: middle;
  //-webkit-box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  //box-shadow: 0 14px 29px 0 rgba(140, 140, 140, 0.35);
  input {
    background: #fff;
    height: 40px;
    margin-top: -10px;
    //width: 133px;
    padding-left: 10px;
    margin-left: -11px;
    padding-right: 5px;
    min-width: 110px;
  }
}

.table-row-style {
  display: flex;
  width: 100%;
  border-top: 0;
  .el-popover__reference {
    float: left;
    color: #404040;
    font-family:$fontSemibold;
    font-size: 1.2rem;
    text-transform: capitalize;
    padding: 9px 10px;
    line-height: 22px;
  }
}
.invoice-popover {
  .popover-primary-header h3 {
    margin-bottom: 6px;
    color: #234357;
    font-family:$fontSemibold;
    text-transform: uppercase;
    font-size: 1.6rem;
  }
}
.comment-pop{
  float: right;
}
.popup-block{
  .primary-text {
    padding-left: 10px;
  }
  .comment-pop{
    position: absolute;
    right: 10px;
    top:9px;
  }
}
</style>
